/**
 * Relay for App Container
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const AppRootQuery = graphql`
  query app_Query {
    viewer {
      ...app_viewer
    }
  }
`;

export const AppFragment = graphql`
  fragment app_viewer on Viewer {
    id
    authentication_info{
      user_pool_id
      client_id
      cognito_domain_url
    }
    business_information{
      ams{
        ...businessInformationNode @relay(mask: false)
      }
    }
    cart{
      ...cartNode @relay(mask: false)
    }
    profile {
      ...profile @relay(mask: false)
    }
    latest_exchange_rates {
      ...exchangeRateNode @relay(mask: false)
    }
    license_components{
      ...licenseBuilderComponentsFragment @relay(mask: false)
    }
    projects(first: 100, scope: CurrentUser) @connection(key: "list_projects", filters: []) {
      edges{
        node{
          ...projectNode @relay(mask: false)
        }
      }
    }
    taxonomies(first: 10000000) {
      edges {
        node {
        	...taxonomyNode @relay(mask: false)
        }
      }
    }
    tempos{
      ...tempoList @relay(mask: false)
    }
    ...selectedCurrency_viewer
    ...header_viewer
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/app.ts